<template>
    <div
        class="component component__logo"
    >
        <div class="component__logo_image">
            <template v-if="fileId">
                <component-image
                    :id="fileId"
                    :clickable="false"
                    :height="height"
                ></component-image>
            </template>
            <template v-else>
                <svg
                    :height="height"
                    viewBox="0 0 120 23"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path d="M37.5253 17.6042V1.17067e-07H40.6224V17.6042H37.5253Z" fill="#111111"/>
                    <path
                        d="M45.1118 12.8519C45.5199 14.371 46.6396 15.1184 48.497 15.1184C49.6734 15.1184 50.5857 14.7085 51.1859 13.9128L53.6828 15.3596C52.5064 17.0715 50.7538 17.9396 48.4446 17.9396C46.4519 17.9396 44.8673 17.3368 43.6669 16.1312C42.4665 14.9255 41.8663 13.4065 41.8663 11.5739C41.8445 10.7373 41.9906 9.90478 42.2958 9.126C42.601 8.34722 43.0592 7.63809 43.6429 7.04081C44.8193 5.81108 46.3559 5.20828 48.2045 5.20828C49.9506 5.20828 51.4216 5.81108 52.55 7.04081C53.1206 7.64531 53.5669 8.3568 53.8635 9.13462C54.1601 9.91243 54.3012 10.7413 54.2786 11.5739C54.2722 12.0024 54.232 12.4297 54.1586 12.8519H45.1118ZM51.1859 10.4406C50.8258 8.80101 49.6254 8.0053 48.2089 8.0053C46.5523 8.0053 45.4239 8.89746 45.0638 10.4406H51.1859Z"
                        fill="#111111"/>
                    <path
                        d="M65.1652 5.54801H68.2623V17.6042H65.1652V16.1794C64.2289 17.3609 62.9324 17.933 61.2518 17.933C60.4732 17.9412 59.7018 17.7819 58.9895 17.4658C58.2773 17.1497 57.6406 16.6842 57.1224 16.1005C55.9904 14.8685 55.3792 13.2432 55.4178 11.5673C55.3793 9.89868 55.9909 8.28085 57.1224 7.05832C58.2748 5.82859 59.6432 5.20167 61.2518 5.20167C62.9324 5.20167 64.2289 5.78036 65.1652 6.95529V5.54801ZM61.8302 14.9738C62.2693 14.9882 62.7067 14.9122 63.1155 14.7505C63.5242 14.5887 63.8957 14.3447 64.207 14.0334C64.5259 13.7111 64.7757 13.3265 64.9408 12.9035C65.106 12.4805 65.1831 12.028 65.1674 11.5739C65.1853 11.1231 65.1091 10.6736 64.9438 10.2542C64.7784 9.83477 64.5274 9.45474 64.207 9.13856C63.569 8.52004 62.7169 8.17437 61.8302 8.17437C60.9435 8.17437 60.0913 8.52004 59.4534 9.13856C59.1409 9.45946 58.8968 9.84086 58.7359 10.2595C58.5749 10.6782 58.5004 11.1254 58.517 11.5739C58.5027 12.0258 58.5781 12.476 58.7388 12.8982C58.8996 13.3205 59.1425 13.7064 59.4534 14.0334C59.7647 14.3447 60.1362 14.5887 60.5449 14.7505C60.9537 14.9122 61.3911 14.9882 61.8302 14.9738Z"
                        fill="#111111"/>
                    <path d="M72.7715 7.61951C73.3477 6.08509 74.7882 5.30472 76.4208 5.30472V8.7769C75.5303 8.64395 74.6225 8.85038 73.8759 9.3556C73.1316 9.86196 72.7715 10.6818 72.7715 11.8392V17.6042H69.6744V5.54804H72.7715V7.61951Z"
                          fill="#111111"/>
                    <path
                        d="M87.6135 6.53444C88.4865 7.42659 88.9099 8.63221 88.9099 10.1995V17.6042H85.8128V10.5897C85.8128 8.97416 84.8765 8.10612 83.436 8.10612C81.8274 8.10612 80.7951 9.09473 80.7951 11.096V17.6042H77.698V5.54802H80.7951V6.89831C81.5393 5.76503 82.7398 5.21045 84.3723 5.21045C85.6928 5.20826 86.7732 5.64228 87.6135 6.53444Z"
                        fill="#111111"/>
                    <path
                        d="M89.7938 2.19422C89.7912 1.81376 89.9013 1.44112 90.1102 1.1237C90.319 0.806274 90.6171 0.558401 90.9666 0.411603C91.3161 0.264805 91.7012 0.225714 92.0729 0.299301C92.4446 0.372889 92.786 0.55583 93.0539 0.82486C93.3218 1.09389 93.5039 1.43685 93.5772 1.81014C93.6505 2.18342 93.6116 2.57015 93.4654 2.92116C93.3192 3.27216 93.0724 3.57158 92.7564 3.78133C92.4403 3.99108 92.0693 4.10169 91.6905 4.09909C91.189 4.09395 90.7095 3.89161 90.355 3.53549C90.0004 3.17936 89.7989 2.69783 89.7938 2.19422ZM90.1539 17.6042V5.54802H93.2597V17.6042H90.1539Z"
                        fill="#111111"/>
                    <path
                        d="M104.609 6.53444C105.472 7.42659 105.906 8.63221 105.906 10.1995V17.6042H102.802V10.5897C102.802 8.97416 101.864 8.10612 100.425 8.10612C98.8168 8.10612 97.7823 9.09473 97.7823 11.096V17.6042H94.6874V5.54802H97.7823V6.89831C98.5265 5.76503 99.727 5.21045 101.362 5.21045C102.682 5.20826 103.763 5.64228 104.609 6.53444Z"
                        fill="#111111"/>
                    <path
                        d="M116.775 5.54806H119.8V17.0233C119.8 18.88 119.176 20.3114 117.952 21.2912C116.727 22.271 115.263 22.7621 113.534 22.7621C110.941 22.7621 108.901 21.7493 107.844 19.8204L110.485 18.3013C111.085 19.4346 112.142 19.9891 113.63 19.9891C115.575 19.9891 116.775 18.9282 116.775 17.0233V15.7213C115.863 16.951 114.593 17.5538 112.934 17.5538C112.137 17.5704 111.346 17.4204 110.61 17.1132C109.875 16.806 109.211 16.3484 108.66 15.7695C107.54 14.5901 106.928 13.0151 106.956 11.3854C106.94 10.579 107.085 9.77767 107.382 9.02826C107.679 8.27884 108.122 7.59646 108.684 7.0211C109.227 6.43674 109.885 5.97367 110.617 5.66207C111.35 5.35048 112.139 5.19735 112.934 5.21268C114.591 5.21268 115.863 5.81549 116.775 7.04521V5.54806ZM115.815 9.04434C115.5 8.73095 115.125 8.48578 114.712 8.32403C114.299 8.16228 113.857 8.08737 113.414 8.10396C112.968 8.08957 112.523 8.1654 112.107 8.32694C111.69 8.48849 111.31 8.73245 110.989 9.04434C110.68 9.34755 110.437 9.71211 110.276 10.1148C110.115 10.5175 110.039 10.9495 110.053 11.3832C110.053 13.3122 111.469 14.6866 113.414 14.6866C115.359 14.6866 116.775 13.3122 116.775 11.3832C116.791 10.9468 116.714 10.5119 116.548 10.1081C116.382 9.70426 116.132 9.34077 115.815 9.04215V9.04434Z"
                        fill="#111111"/>
                    <path
                        d="M22.3256 12.8519C22.7338 14.3709 23.8534 15.1184 25.7108 15.1184C26.8872 15.1184 27.7996 14.7085 28.3998 13.9128L30.8966 15.3596C29.7202 17.0715 27.9676 17.9396 25.6584 17.9396C23.6657 17.9396 22.0812 17.3368 20.8808 16.1311C19.6803 14.9255 19.0801 13.4065 19.0801 11.5739C19.0583 10.7373 19.2044 9.90477 19.5096 9.12599C19.8149 8.34721 20.273 7.63808 20.8567 7.04081C22.0332 5.81108 23.5697 5.20827 25.4184 5.20827C27.1644 5.20827 28.6355 5.81108 29.7639 7.04081C30.3344 7.64531 30.7807 8.3568 31.0773 9.13461C31.3739 9.91243 31.515 10.7413 31.4925 11.5739C31.486 12.0024 31.4459 12.4297 31.3724 12.8519H22.3256ZM28.3998 10.4406C28.0396 8.801 26.8392 8.0053 25.4227 8.0053C23.7661 8.0053 22.6377 8.89745 22.2776 10.4406H28.3998Z"
                        fill="url(#paint0_linear)"/>
                    <path
                        d="M13.2767 5.20827C11.6921 5.20827 10.4917 5.78696 9.69942 6.94436C9.00317 5.78696 7.89878 5.20827 6.42554 5.20827C4.913 5.20827 3.80643 5.73874 3.08836 6.82379V5.54803H0V17.6042H3.09709V10.8264C3.09709 9.07282 3.9854 8.10175 5.35389 8.10175C6.62633 8.10175 7.3706 8.94568 7.3706 10.3924V17.6042H10.4677V10.8264C10.4677 9.07282 11.284 8.10175 12.7005 8.10175C13.9729 8.10175 14.7172 8.94568 14.7172 10.3924V20.1601L16.2668 19.0641L17.8121 20.1601V10.1754C17.8143 7.16137 16.0376 5.20827 13.2767 5.20827Z"
                        fill="url(#paint1_linear)"/>
                    <defs>
                        <linearGradient id="paint0_linear" x1="0" y1="5.20827" x2="31.4948" y2="5.20827"
                                        gradientUnits="userSpaceOnUse">
                            <stop stop-color="#0074D9"/>
                            <stop offset="1" stop-color="#0057AD"/>
                        </linearGradient>
                        <linearGradient id="paint1_linear" x1="0" y1="5.20827" x2="31.4948" y2="5.20827"
                                        gradientUnits="userSpaceOnUse">
                            <stop stop-color="#0074D9"/>
                            <stop offset="1" stop-color="#0057AD"/>
                        </linearGradient>
                    </defs>
                </svg>
            </template>
        </div>
        <template v-if="label">
            <component-text
                :key="rerenderIndex"
                :class="'component__logo_label'"
                :size="'small'"
            >{{ label }}
            </component-text>
        </template>
    </div>
</template>

<script>

import ComponentText from '@/components/default/shared/ComponentText'

export default {
  name: 'component-logo',
  components: {
    ComponentText,
    ComponentImage: () => import('@/components/default/shared/ComponentImage')
  },
  data () {
    return {
      rerenderIndex: 0
    }
  },
  props: {
    fileId: {
      type: String
    },
    label: {
      type: String
    },
    height: {
      type: Number,
      default: 25
    }
  },
  watch: {
    label () {
      this.rerenderIndex++
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/default/shared/componentlogo";
</style>
